import { listenerMiddleware } from './listener.middleware';
import { isFulfilled } from '@reduxjs/toolkit';
import { doctorBffApi } from '@/modules';
import { RootState } from '../appStore';
import { constructProtocolCacheKey, ProtocolName } from '@/modules/protocol';

const excludedEndpoints = ['keepAlive'];

/* eslint-disable @typescript-eslint/ban-ts-comment */
listenerMiddleware.startListening({
  predicate: (action) =>
    // Check if this is a fulfilled mutation from doctorBffApi
    isFulfilled(action) &&
    action.type.startsWith('doctorBffApi/') &&
    // @ts-expect-error
    action.meta?.arg?.type === 'mutation' &&
    // @ts-expect-error
    !excludedEndpoints.includes(action.meta?.arg?.endpointName),
  effect: (action, api) => {
    const state = api.getState() as RootState;
    const shouldInvalidate =
      state.appContext._tempListenForSurgeryPlanningProtocolStatusUpdates;
    if (shouldInvalidate) {
      const patientId = (action.meta as any)?.arg?.originalArgs?.patientId;
      const protocolCacheKey = patientId
        ? constructProtocolCacheKey({
            patientId,
            protocol: ProtocolName.SURGERY_PLANNING
          })
        : ProtocolName.SURGERY_PLANNING;
      api.dispatch(
        doctorBffApi.util.invalidateTags([
          'Dashboard',
          { type: 'ProtocolStatuses', id: patientId },
          { type: 'Protocol', id: protocolCacheKey }
        ])
      );
    }
  }
});
